import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_38: FaireProductEntity = {
  token: "catalog_prod_prod-38",
  type: "product",
  name: "Decorative Item B - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400&h=400&fit=crop",
  priceDollars: 86.24,
  msrpDollars: 215.6,
  sku: "PA0038",
  caseSize: 1,
  material: "Metal",
  collectionToken: "col_pattern-play",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 442,
  description: "Beautiful Pattern Play piece perfect for any home.",
  categoryTokens: ["cat_household-all"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
